import styled, { css } from 'styled-components';

interface TabItemProps {
  isActive?: boolean;
}

export const Root = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 30;
`;

export const HeaderWrapper = styled.div`
  position: relative;
`;

export const ButtonClose = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  width: 20px;
  height: 20px;
`;

export const Bg = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.8;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.palette.grayscale800};
  z-index: 20;
`;

export const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  width: 100%;
  max-width: 335px;
  z-index: 21;
  padding: 24px;
  border-radius: 20px;
  background-color: ${({ theme }) => theme.palette.bg800};
`;

export const Title = styled.h2`
  margin-bottom: 4px;
  color: ${({ theme }) => theme.palette.grayscale400};
  ${({ theme }) => theme.typography('$title_03')};
`;

export const TextareaWrapper = styled.div`
  margin-bottom: 32px;
`;

export const TabListWrapper = styled.div`
  display: flex;
  margin-bottom: 12px;
`;

export const TabItem = styled.button<TabItemProps>`
  position: relative;
  width: 100%;
  height: 46px;
  color: ${({ theme }) => theme.palette.grayscale400};
  text-align: center;
  ${({ theme }) => theme.typography('$body_01')};

  ${({ isActive }) =>
    isActive &&
    css`
      &::before {
        content: '';
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 2px;
        background-color: ${({ theme }) => theme.palette.brand400};
      }
    `}
`;

export const Textarea = styled.textarea`
  width: 100%;
  height: 200px;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.bg500};
  color: ${({ theme }) => theme.palette.grayscale300};
  background-color: ${({ theme }) => theme.palette.bg800};
  outline: 0;
  ${({ theme }) => theme.typography('$body_03')};

  &::placeholder {
    color: ${({ theme }) => theme.palette.grayscale700};
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0 12px;
`;

export const Button = styled.button`
  width: 100%;
  height: 46px;
  color: ${({ theme }) => theme.palette.grayscale400};
  background-color: ${({ theme }) => theme.palette.bg500};
  text-align: center;
  border-radius: 8px;
  ${({ theme }) => theme.typography('$body_01')};
`;

export const ButtonPrimary = styled(Button)`
  color: ${({ theme }) => theme.palette.grayscale100};
  background-color: ${({ theme }) => theme.palette.brand400};
`;
